import Button from "@/components/Button";
import { prefillDevJobForm } from "./prefillDevJobForm";
import useCurrentUser from "@/hooks/useCurrentUser";

interface DevPrefillJobFormButtonProps {
  setValue: (name: any, value: any) => void;
  clearErrors: (...args: any[]) => void;
  setSelectedSectionId: (id: string) => void;
  jobCategories: string[];
}

const DevPrefillJobFormButton = ({
  setValue,
  clearErrors,
  setSelectedSectionId,
  jobCategories
}: DevPrefillJobFormButtonProps) => {
  const { user: currentUser } = useCurrentUser();

  const handleClick = () => {
    prefillDevJobForm({
      setValue,
      clearErrors,
      setSelectedSectionId,
      jobCategories,
      currentUser
    });
  };

  return (
    <div className="mt-2">
      <Button variant="outlined" testId="dev-prefill-external-job-url-button" onClick={handleClick}>
        Prefill Job Form
      </Button>
    </div>
  );
};

export default DevPrefillJobFormButton;
